export { default as ShippingDetail } from "./ShippingDetail.vue";
export { default as LanterShippingDetail }  from "./LanterShipping/LanterShippingDetail.vue";